
        var result = require("!!../../../../../node_modules/css-loader/index.js!./document-template-dialog.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/bookmark-templates/document-template-dialog/document-template-dialog.component.css
// module id = 765
// module chunks = 0